import React from 'react';
import { Link } from 'react-router-dom';
import PhotoGallery from '../Component/PhotoGallery';
import YLSLOGO from '../Assets/YLSNLOGO.jpg';
import Cards from '../Component/Cards';

const Home = () => {
  const metricsData = [
    { number: '12+', label: 'Years Serving Community', subtext: 'Established in 2012' },
    { number: '3', label: 'Core Programs', subtext: 'Back2LIFE, 1Life2Live, L.E.A.D.' },
    { number: '2', label: 'Capital Region Hubs', subtext: 'Schenectady & Albany, NY' },
    { number: '100%', label: 'Confidential Support', subtext: 'Community Outreach Team' }
  ];

  const pillarsData = [
    {
      icon: 'fa-shield-heart',
      title: 'Violence Prevention & Intervention',
      desc: 'Proactive street outreach, crisis mediation, and gun violence reduction to protect youth and save lives.'
    },
    {
      icon: 'fa-graduation-cap',
      title: 'Youth Empowerment & Education',
      desc: 'Mentorship, skill building, educational support, and giving youth a seat at the table to shape their future.'
    },
    {
      icon: 'fa-people-roof',
      title: 'Family & Reintegration Support',
      desc: 'Pre-booking diversion, discharge planning, and comprehensive wrap-around services for families in need.'
    }
  ];

  return (
    <div className="home-page">
      {/* 1. Hero Carousel */}
      <PhotoGallery />

      {/* 2. Key Impact Metrics Bar */}
      <section className="impact-metrics-bar">
        <div className="metrics-grid">
          {metricsData.map((item, index) => (
            <div key={index} className="metric-card">
              <span className="metric-number">{item.number}</span>
              <span className="metric-label">{item.label}</span>
              <span className="metric-subtext">{item.subtext}</span>
            </div>
          ))}
        </div>
      </section>

      {/* 3. Our Mission & Core Pillars Section */}
      <section className="mission-section">
        <div className="mission-container">
          <div className="mission-image-wrapper">
            <img src={YLSLOGO} alt="Youth L.I.F.E. Support Network Logo" className="mission-logo-img" />
            <div className="mission-badge">
              <i className="fa-solid fa-hand-holding-heart"></i>
              <span>Serving Capital Region Youth & Families</span>
            </div>
          </div>

          <div className="mission-content">
            <span className="section-subtitle">WHO WE ARE & WHAT WE STAND FOR</span>
            <h2 className="section-title">Our Mission & Community Pillars</h2>
            <p className="mission-text">
              To impact violence by providing proactive outreach, violence prevention & intervention, educational support, recreation, and advocacy to youth — giving them a seat at the table to help shape the direction and future of our community.
            </p>

            <div className="pillars-grid">
              {pillarsData.map((pillar, idx) => (
                <div key={idx} className="pillar-item">
                  <div className="pillar-icon">
                    <i className={`fa-solid ${pillar.icon}`}></i>
                  </div>
                  <div className="pillar-info">
                    <h4>{pillar.title}</h4>
                    <p>{pillar.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mission-actions">
              <Link to="/about" className="btn-brand-primary">
                Learn More About Us <i className="fa-solid fa-arrow-right"></i>
              </Link>
              <Link to="/contact" className="btn-brand-outline">
                Contact Our Team
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 4. Programs Cards Grid */}
      <section className="our-pb-section">
        <Cards />
      </section>

      {/* 5. Bottom Elevator Pitch CTA Banner */}
      <section className="elevator-pitch">
        <div className="e-p-photo-container">
          <img
            src="https://images.unsplash.com/photo-1536337005238-94b997371b40?q=80&w=2069&auto=format&fit=crop"
            alt="Youth & Family Empowerment"
          />
          <div className="e-p-overlay">
            <div className="e-p-text">
              <h3>Empowering youth and families with essential resources and tools to catalyze positive transformations and foster growth.</h3>
              
              <div className="e-p-icons">
                <span><i className="fa-solid fa-circle-check"></i> Education</span>
                <span><i className="fa-solid fa-circle-check"></i> Research</span>
                <span><i className="fa-solid fa-circle-check"></i> Organization</span>
                <span><i className="fa-solid fa-circle-check"></i> Advocacy</span>
              </div>

              <div className="e-p-cta-actions">
                <Link to="/contact" className="cta-call-btn">
                  Get In Touch <i className="fa-solid fa-arrow-right"></i>
                </Link>
                <Link to="/programs" className="cta-events-btn">
                  Explore Programs
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;